import { useCallback } from 'react'
import type { MutationHook } from '@commerce/utils/types'
import useApplyDiscount, { UseApplyDiscount } from '@commerce/cart/use-apply-discount'
import type { ApplyDiscountHook } from '../types/cart'
import useCart from './use-cart'

import {
  getCheckoutId,
  checkoutToCart,
  checkoutDiscountApplyMutation,
} from '../utils'
import { Mutation, MutationCheckoutLineItemsAddArgs } from '../schema'

export default useApplyDiscount as UseApplyDiscount<typeof handler>

export const handler: MutationHook<ApplyDiscountHook> = {
  fetchOptions: {
    query: checkoutDiscountApplyMutation,
  },
  async fetcher({ input: { discountCode }, options, fetch }) {
    const checkoutId = getCheckoutId()

    const { checkoutDiscountCodeApplyV2 } = await fetch<
      Mutation,
      MutationCheckoutLineItemsAddArgs
    >({
      ...options,
      variables: {
        checkoutId: checkoutId,
        discountCode: discountCode
      },
    })

    return checkoutToCart(checkoutDiscountCodeApplyV2)
  },
  // @ts-ignore
  useHook: ({ fetch }) => ()  => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { mutate } = useCart()

    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useCallback(
      async function applyDiscount(input) {
        try {
          const data = await fetch({ input })
          await mutate(data, false)
          return data
        } catch (e) {
          return e
        }
      },
      [mutate]
    )
  },
}
